var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"optional-tag",class:_vm.tagType},[_vm._v(" "+_vm._s(_vm.jikokuValue)+" "),(_vm.optionString)?_c('span',{staticClass:"optional-tag-circle"},[_vm._v(" "+_vm._s(_vm.optionString)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }